import styled from '@emotion/styled';
import { Dialog, LinearProgress } from '@mui/material';
import { Bookmark, LikertForm } from '../../styles';
import { breakpoints } from 'Styles/theme';
import { black, teal } from 'Styles/colors';
import { leaf } from 'Assets/img/screening-icons';

export const StyledLikertForm = styled(LikertForm)(
  ({ theme }) => `
  width: 100%;
  flex-flow: wrap;
  justify-content: center;
  column-gap: 30px;

  ${theme.breakpoints.up(breakpoints.DESKTOP)} {
    max-width: 380px;
  }

  .FormQuestion-answer-card {
    width: 147px;
    height: 115px;
  }
`,
);

export const NeedsWrapper = styled(Dialog)(
  ({ theme }) => `

  h1 {
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    margin: 32px auto;
  }
  
  ${theme.breakpoints.up(breakpoints.TABLET)} {
    h1 {
      font-size: 24px;
    }
  }

  .MuiDialog-scrollPaper {
    background-image: linear-gradient(rgba(0, 0, 0, 0.68), rgba(0, 0, 0, 0.68)), url(${leaf}), linear-gradient(black, black);
    background-size: cover;
    background-position: right;
    background-repeat: no-repeat;
  }

  .MuiDialog-paper {
    display: grid;
    grid-template-rows: 1fr 2fr 1fr;
    background-color: transparent;
    color: white;
    align-items: center;
    justify-content: center;
  }

  ${theme.breakpoints.up(breakpoints.TABLET)} {
    .MuiDialog-paper {
      grid-template-rows: 1fr 5fr 1fr;
    }
  }
  `,
);

export const NeedsProgressBar = styled(LinearProgress)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 9px;
  margin-top: env(safe-area-inset-top);

  .MuiLinearProgress-bar {
    background-color: ${teal._400};
  }
`;

export const StyledBookmark = styled(Bookmark)`
  top: calc(9px + env(safe-area-inset-top));
`;

export const StyledNeedsForm = styled.div`
  .FormQuestion-root {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .FormQuestion-wrapper-question {
    background-color: ${(props) => (props.cardColor ? props.cardColor : '#565c89')};
    height: 395px;
    width: 285px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    border-radius: 4px;
    box-shadow: 0 12px 0 -10px grey, 0 16px 0 -12px lightgrey, 0 18px 0 -13px grey, 0 22px 0 -15px lightgrey,
      0 24px 0 -16px grey;
    margin-bottom: 24px;
  }
  .FormQuestion-question {
    font-size: 24px;
    font-weight: 700;
    margin: auto 24px;
  }
  .FormAnswer-root {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    margin: auto;
    padding: 0;
  }
  .MuiFormControlLabel-root {
    margin: 0;
  }
  .FormQuestion-answer-unchecked,
  .FormQuestion-answer-checked {
    height: 48px;
    width: 100px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 700;
  }
  .FormQuestion-answer-unchecked {
    background-color: ${black._100};
    color: white;
  }
`;
